export function usePdfScrollTracker(pagesContainer, pages) {
  const pagePositions = {}

  const getPageElement = (n) => {
    if (!pagesContainer.value) return null
    return pagesContainer.value.querySelector(`[data-page="${n}"]`)
  }

  const updatePositions = () => {
    for (let n = 1; n <= pages.value; n++) {
      const el = getPageElement(n)
      pagePositions[n] = el ? el.offsetTop : 0
    }
  }

  const trackScroll = (currentPage) => {
    if (!pagesContainer.value) return

    const containerRect = pagesContainer.value.getBoundingClientRect()
    const viewportCenter = containerRect.top + containerRect.height / 2

    let closestPage = 1
    let closestDistance = Infinity

    // Encontrar a página cujo centro está mais próximo do centro do viewport
    for (let n = 1; n <= pages.value; n++) {
      const el = getPageElement(n)
      if (!el) continue

      const pageRect = el.getBoundingClientRect()
      const pageCenter = pageRect.top + pageRect.height / 2
      const distance = Math.abs(viewportCenter - pageCenter)

      if (distance < closestDistance) {
        closestDistance = distance
        closestPage = n
      }
    }

    currentPage.value = closestPage
  }

  return { updatePositions, trackScroll, getPageElement }
}
